import { SlideWaveBackground } from "@/components/investors/slides/SlideWaveBackground";

export function V3CoverSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="relative flex flex-col justify-end h-full">
      <SlideWaveBackground />
      <div className="relative z-10 max-w-4xl mt-auto">
        <h1 className="text-[48px] font-light tracking-tight mb-6 font-[family-name:var(--font-heading)]">
          The AI Back-Office<br />for Professional Services
        </h1>
        <p className="text-[18px] text-[var(--color-fg-secondary)] leading-relaxed font-light">
          Don&apos;t sell software. Do the work.
        </p>
      </div>
    </div>
  );
}
